/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdFolders200,
  GetApiV1ClassroomdisciplineIdFolders401,
  GetApiV1ClassroomdisciplineIdFolders404,
  GetApiV1ClassroomdisciplineIdFoldersPathParams,
  GetApiV1ClassroomdisciplineIdFoldersQueryResponse,
} from "../../types/classPlanningMaterialController/GetApiV1ClassroomdisciplineIdFolders.ts";
import { classroomDisFolderItemViewModelSchema } from "../classroomDisFolderItemViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdFoldersPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ClassroomdisciplineIdFoldersPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdFolders200Schema = z.array(
  z.lazy(() => classroomDisFolderItemViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdFolders200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdFolders401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdFolders401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdFolders404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdFolders404>;

export const getApiV1ClassroomdisciplineIdFoldersQueryResponseSchema = z.lazy(
  () => getApiV1ClassroomdisciplineIdFolders200Schema,
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdFoldersQueryResponse>;
